/**
 * Lightweight read-only auth state hook for the MARKETING site.
 *
 * Reads EXCLUSIVELY from the global `AuthProvider` (mounted at the App
 * root) so the marketing header sees the same user + profile snapshot
 * the workspace already trusts. No second session subscription, no race
 * with the global AuthProvider, when `profile.first_name` arrives, the
 * hook re-renders and the chip updates to "G'day {firstName}".
 *
 * Name resolution mirrors the dashboard hero ONE-FOR-ONE so the chip
 * never disagrees with the page underneath it:
 *   1. profile.first_name
 *   2. user_metadata.first_name
 *   3. user_metadata.full_name (split on first space)
 *
 * Returns '' if nothing is available, caller is expected to render a
 * neutral greeting in that case.
 */
import { useAuth } from '../workspace/context/AuthContext';

export const useMarketingAuth = () => {
  const { user, profile, loading } = useAuth() || {};

  const meta = user?.user_metadata || {};
  const firstName = (
    profile?.first_name ||
    meta.first_name ||
    (meta.full_name || '').split(' ')[0] ||
    ''
  ).trim();
  const initial = (firstName ? firstName[0] : 'U').toUpperCase();

  return {
    loading: !!loading,
    isLoggedIn: Boolean(user),
    user,
    profile,
    firstName,
    initial,
  };
};
